<template>
    <footer class="cc-footer-container">
        <div class="cc-footer-content">
            <ul class="cc-footer-nav">
                <li
                    v-for="(item, index) in linkList" :key="index"
                >
                    <h4>{{ item.title }}</h4>
                    <ul>
                        <li v-for="(subItem, subIndex) in item.children" :key="subIndex">
                            <a
                                rel="noreferrer noopener" :href="subItem.target"
                                target="_blank"
                            >{{ subItem.name }}
                            </a></li>
                    </ul>
                </li>
            </ul>
            <div class="cc-footer-qrcode">
                <h4>扫描关注二维码</h4>
                <img alt="" src="../assets/indexQrcode.png">
            </div>
        </div>
        <div class="cc-footer-copyright">
            {{ `©${new Date().getFullYear()}` }}&nbsp;Baidu
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.baidu.com/duty"
            >使用百度前必读</a>&nbsp;
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001"
            >京公网安备11000002000001号</a>&nbsp;
            <span>互联网信息服务许可</span>&nbsp;
            <span>我已阅读并接受</span>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://e.baidu.com/accept.html"
            >百度推广服务合同</a>&nbsp;
            <span class="protocol-btn" @click="handleShowProtocol">擎舵平台服务协议</span>&nbsp;
            <span>欢迎访问</span>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://rules.baidu.com/userpolicy"
            >百度推广政策中心</a>
        </div>

        <cc-protocol
            v-if="openProtocol"
            :open.sync="openProtocol"
        />
    </footer>
</template>

<script>
import {linkList} from '../config';
import {platformProtocolPath} from '@/config/default';

export default {
    name: 'cc-footer',
    inject: ['$toast'],
    components: {
    },
    data() {
        return {
            linkList,
            openProtocol: false
        };
    },
    methods: {
        handleShowProtocol() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const url = `${prefix}${platformProtocolPath}`;
            window.open(url, '_blank', 'noreferrer');
        }
    }
};

</script>

<style lang="less" scoped>
.cc-footer {
    &-container {
        background: #F6F7FA;
        position: relative;
        padding-top: 40px;
        // max-width: 1920px;
        margin: 0 auto;
    }
    &-content {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-bottom: 25px;
    }
    &-nav {
        text-align: left;
        display: flex;
        margin: 0;
        li {
            margin-top: 18px;
            a {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #848B99;
                white-space: nowrap;
                text-decoration: none;
                outline: none;
            }
        }
        h4 {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #545B66;
            margin: 0;
        }
        > li {
            width: 148px;
        }
    }
    &-qrcode {
        h4 {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #545B66;
            margin: 0;
        }
        img {
            width: 100px;
            height: 100px;
            margin-top: 14px;
        }
    }
    &-copyright {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #848B99;
        width: 1240px;
        height: 76px;
        border-top: 1px solid #E2E6F0;
        text-align: center;
        padding: 24px 0 32px;
        margin: 0 auto;
        a {
            color: #848B99;
        }
        .protocol-btn {
            cursor: pointer;
        }
    }
}
</style>